module.exports = __webpack_public_path__ + "img/THA.e6c76ee9.svg";